import styled from "styled-components";
import {
  ACCENT_PRIMARY_LIGHTEST_HOVER,
  BRAND,
  BRAND_LIGHT,
  WHITE
} from "@streeteasy/design-system/colors";
import Tooltip from "@streeteasy/design-system/legacy/Tooltip";
import { SecondaryLarge } from "@streeteasy/design-system/typography";

import { smallScreen } from "src/shared/constants/screenSizes";

export const TooltipWrapper = styled(Tooltip).attrs({ width: "188px" })`
  vertical-align: inherit;

  #tooltip-content {
    box-sizing: border-box;
  }
`;

export const Dashed = styled(SecondaryLarge).attrs({ as: "span" })`
  border-bottom: 2px dashed ${BRAND};
`;

export const SectionCardBody = styled(SecondaryLarge)`
  margin-top: 16px;
`;

export const SectionCardButtonContainer = styled.div`
  background: ${ACCENT_PRIMARY_LIGHTEST_HOVER};
  margin-top: auto;
  padding: 32px 0;
`;

export const SectionCardContainer = styled.div`
  background-color: ${WHITE};
  border-top: 2px solid ${BRAND_LIGHT};
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  max-width: 420px;
  width: 100%;

  &:not(:last-child) {
    margin-right: 24px;
  }

  @media screen and (max-width: ${smallScreen}px) {
    &:not(:last-child) {
      margin: 0 0 24px;
    }
  }
`;

export const SectionCardCopyContainer = styled.div`
  padding: 36px 30px 46px;
`;
